import {
  GET_BACKEND_URL,
  LOADING_COMPLETED_FAILURE,
  LOADING_COMPLETED_SUCCESS,
  LOADING_PRISTINE,
  LOADING_STARTED,
  SET_SURVEY,
  GET_SURVEY,
  SET_USER_POSITION_IN_SURVEY,
  USER_POSITION_IN_SURVEY,
  SET_REDIRECT_URL,
  COMPLETE_SURVEY,
  GET_SURVEY_PREVIEW,
  SET_SURVEY_PREVIEW,
  SET_I18N_LANGUAGE,
  GET_SESSION_TOKEN,
  IS_SURVEY_RTL,
} from "../services/constants";
import http from "../services/axios";
import i18n from "../i18n";

const module = {
  state: {
    survey: {
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    userPositionInSurvey: {
      sendToPrelim: false,
      postPrelimToServer: false,
      sendToPreQuestion: false,
      sendToAdditionalQuestion: false,
      sendToPostSurveyPresentation: false,
      sendToCompletedPage: true,
      sendToPrepresentation: false,
    },
    redirectURL: "",
    isSurveyPreview: false,
  },
  getters: {
    [IS_SURVEY_RTL](state) {
      if (state.survey.data.study) {
        return state.survey.data.study.language === "he";
      }
    },
  },
  mutations: {
    [SET_SURVEY](state, payload) {
      state.survey = payload;
    },
    [SET_USER_POSITION_IN_SURVEY](state, payload) {
      state.userPositionInSurvey = Object.assign({}, state.userPositionInSurvey, payload);
    },
    [SET_REDIRECT_URL](state, payload) {
      state.redirectURL = payload;
    },
    [SET_SURVEY_PREVIEW](state, payload) {
      state.isSurveyPreview = payload;
    },
  },
  actions: {
    [GET_SURVEY](context, id) {
      context.commit(SET_SURVEY, {
        loadingState: LOADING_STARTED,
        data: context.state.survey.data,
        error: context.state.survey.error,
      });
      return http
        .get(context.getters[GET_BACKEND_URL](`surveys/${id}`))
        .then((response) => {
          if (response.data.status === "open") {
            const hasPrepresentation = !!response.data.study.prePresentation && response.data.study.prePresentation.length > 0;
            const hasPostSurveyPresentation = !!response.data.study.postPresentation && response.data.study.postPresentation.length > 0;
            const hasOptionalQuestion = typeof response.data.study.optionalQuestion === "string";
            const hasOptionalPreQuestion = !!response.data.study.optionalPreQuestion
            context.commit(SET_USER_POSITION_IN_SURVEY, {
              sendToPrelim: response.data.participant.gender === 0,
              sendToPrepresentation: hasPrepresentation,
              postPrelimToServer: !hasPrepresentation,
              sendToPostSurveyPresentation: hasPostSurveyPresentation,
              sendToAdditionalQuestion: hasOptionalQuestion,
              sendToPreQuestion: hasOptionalPreQuestion,
              sendToCompletedPage: true,
            });
          }

          context.commit(SET_SURVEY, {
            loadingState: LOADING_COMPLETED_SUCCESS,
            data: response.data,
            error: null,
          });

          context.commit(SET_I18N_LANGUAGE, response.data.study.language);
        })
        .catch((err) => {
          context.commit(SET_SURVEY, {
            loadingState: LOADING_COMPLETED_FAILURE,
            data: null,
            error: err,
          });
        });
    },
    [GET_SURVEY_PREVIEW](context, studyID) {
      context.commit(SET_SURVEY, {
        loadingState: LOADING_STARTED,
        data: context.state.survey.data,
        error: context.state.survey.error,
      });
      return http
        .get(context.getters[GET_BACKEND_URL](`surveys/preview/${studyID}`))
        .then((response) => {
          if (response.data.status === "open") {
            const hasPrepresentation = response.data.study.prePresentation && response.data.study.prePresentation.length > 0;
            const hasPostSurveyPresentation = response.data.study.postPresentation && response.data.study.postPresentation.length > 0;
            const hasOptionalQuestion = typeof response.data.study.optionalQuestion === "string";
            const hasOptionalPreQuestion = !!response.data.study.optionalPreQuestion
            context.commit(SET_USER_POSITION_IN_SURVEY, {
              sendToPrelim: true,
              sendToPrepresentation: hasPrepresentation,
              postPrelimToServer: !hasPrepresentation,
              sendToPostSurveyPresentation: hasPostSurveyPresentation,
              sendToAdditionalQuestion: hasOptionalQuestion,
              sendToPreQuestion: hasOptionalPreQuestion,
              sendToCompletedPage: true,
            });
          }
          if (response.data.status === "published") {
            throw new Error(
              "Your study is already published, go back to the dashboard to access this study"
            );
          }

          context.commit(SET_I18N_LANGUAGE, response.data.study.language);

          context.commit(SET_SURVEY, {
            loadingState: LOADING_COMPLETED_SUCCESS,
            data: response.data,
            error: null,
          });
        })
        .catch((err) => {
          context.commit(SET_SURVEY, {
            loadingState: LOADING_COMPLETED_FAILURE,
            data: null,
            error: err,
          });
        });
    },
    [USER_POSITION_IN_SURVEY](context, payload) {
      context.commit(SET_USER_POSITION_IN_SURVEY, payload);
    },
    [COMPLETE_SURVEY](context, uniqueIdentifier) {
      http
        .post(context.getters[GET_BACKEND_URL](`surveys/${uniqueIdentifier}/complete`))
        .then((response) => {
          if (
            "redirectURL" in response.data && context.state.survey.data.study.brand === "prospx"
          ) {
            context.commit(SET_REDIRECT_URL, response.data.redirectURL);
            context.commit(SET_USER_POSITION_IN_SURVEY, {
              postPrelimToServer: false,
              sendToCompletedPage: true,
            });
          } else
            if ("redirectURL" in response.data) {
            context.commit(SET_REDIRECT_URL, response.data.redirectURL);
            context.commit(SET_USER_POSITION_IN_SURVEY, {
              postPrelimToServer: false,
              sendToCompletedPage: false,
            });
          } else {
            context.commit(SET_USER_POSITION_IN_SURVEY, { postPrelimToServer: false });
          }
        });
    },
  },
};

export default module;
export const surveyModule = module;
